<template>
    <HeadingContainer heading="My Rentals & Listings">
        <div class="row mt3 mt4-ns">
            
            <!-- menus -->
            <div v-if="!smallOrLess" class="col-xs-4 col-lg-4">
                <RentalsMenuCard/>
                <ListingsMenuCard class="mt4"/>
                <InvoicesMenuCard class="mt4"/>
            </div>

            <!-- page content -->
            <div class="col-xs-12 col-md-8 col-lg-8">
                <div class="mb3 mb4-ns">
                    <slot></slot>
                </div>
            </div>

        </div>
    </HeadingContainer>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import RentalsMenuCard from '@/components/rentalsListings/menus/RentalsMenuCard.vue';
import ListingsMenuCard from '@/components/rentalsListings/menus/ListingsMenuCard.vue';
import InvoicesMenuCard from '@/components/rentalsListings/menus/InvoicesMenuCard.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        HeadingContainer,
        RentalsMenuCard,
        ListingsMenuCard,
        InvoicesMenuCard
    },
    computed: {
        ...mapState('activeListings', ['listings']),
        ...mapState('rentals', ['upcomingRentals']),
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    },
    methods: {
        ...mapActions('activeListings', ['getActiveListings']),
        ...mapActions('rentals', ['getUpcomingRentals'])
    },
    created: function() {
        this.getActiveListings();
        this.getUpcomingRentals();
    }
};
</script>
